import { render } from "./RegStepFillData.vue?vue&type=template&id=770c5f5e"
import script from "./RegStepFillData.vue?vue&type=script&lang=js"
export * from "./RegStepFillData.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__